import moment from 'moment-timezone'

export default (data) => {
    if (data) {
        return moment(data).format('DD/MM/YYYY')
    }
    return '-'
}
